import { z } from 'zod'

import { SWAP_ROUTERS } from '~/components/forms/swap/utils'
import {
  accountSchema,
  baseTransactionSchema,
  tokenAmountSchema,
} from '~/components/smart-accounts/schemas'
import { EarnAction } from '~/types'

export const earnSchema = baseTransactionSchema
  .and(
    z.object({
      account: accountSchema,
      asset: tokenAmountSchema,
      assetUSD: z.string().optional(),
      vault: tokenAmountSchema,
      action: z.enum([EarnAction.DEPOSIT, EarnAction.WITHDRAW]),
      pauseAutoEarnSeconds: z.number().optional(),
      swapData: z
        .object({
          sellToken: tokenAmountSchema.optional(),
          sellTokenUSD: z.string().optional(),
          providerTransactionId: z.string().optional(),
          swapRouter: z.enum(SWAP_ROUTERS),
        })
        .optional(),
    }),
  )
  .refine((data) => {
    if (data.action === EarnAction.DEPOSIT) {
      return data.swapData !== undefined
    }
    return true
  })

export type EarnFormValues = z.input<typeof earnSchema>
